import React, { useContext, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Sidebar as ProSidebar, Menu, MenuItem } from 'react-pro-sidebar';
import { Sidebar as PrimeSidebar } from 'primereact/sidebar';

import "./menu.css";
import NavContext from '../../contexts/NavContext';
import { Divider } from 'primereact/divider';
import ArrowDown from '../../assets/icons/arrow-down.svg';
import Navbar from 'react-bootstrap/Navbar';

// Icons
import CircleLogo from '../../assets/images/image.png';
import Logo from '../../assets/images/logo-panel.svg';
import Logo2 from '../../assets/images/logo2.svg';
import Dashboard from '../../assets/icons/dashboard.svg';
import User from '../../assets/icons/menu/profile.svg';
import Shop from '../../assets/icons/menu/shop.svg';
import Home from '../../assets/icons/menu/home.svg';
import Notif from '../../assets/icons/menu/notif.svg';
import Card from '../../assets/icons/menu/card.svg';
import Message from '../../assets/icons/menu/message.svg';
import Heart from '../../assets/icons/menu/heart.svg';
import Info from '../../assets/icons/menu/info.svg';
import Logout from '../../assets/icons/menu/logout.svg';
import Report from '../../assets/icons/menu/report.svg';
import Search from '../../assets/icons/search.svg'
import Basket from '../../assets/icons/menu/shopIcon.svg'
import MenuIcon from '../../assets/icons/menu/menu.svg';

//active
import HomeActive from '../../assets/icons/menu/active/home.svg';
import BasketActive from '../../assets/icons/menu/active/basket.svg';
import CardActive from '../../assets/icons/menu/active/card.svg';
import BasketCardActive from '../../assets/icons/menu/active/basket-card.svg';
import MessageActive from '../../assets/icons/menu/active/ticket.svg';
import NotifActive from '../../assets/icons/menu/active/notif.svg';
import HeartActive from '../../assets/icons/menu/active/heart.svg';
import InfoActive from '../../assets/icons/menu/active/info.svg';
import ReportActive from '../../assets/icons/menu/active/report.svg';
import LocationActive from '../../assets/icons/menu/active/location.svg';
import ShopActive from '../../assets/icons/menu/active/shop.svg';
import HeadphoneActive from '../../assets/icons/menu/active/headphone.svg';
import UserActive from '../../assets/icons/menu/active/profile.svg';
const MenuComponent = () => {
  const [collapsed, setCollapsed] = useState(true);
  const { setNav } = useContext(NavContext);
  const [searchText, setSearchText] = useState('');
  const [visibleRight, setVisibleRight] = useState(false);

  // دریافت مسیر فعلی
  const location = useLocation();
  const currentPath = location.pathname;

  // تعیین کلاس active بر اساس مسیر فعلی
  const isActive = (path) => (currentPath === path ? 'active menu-item' : 'menu-item');


  const logout = () => {
    localStorage.removeItem("userInfo");
    window.location.href = '/'
  }
  return (
    <>
      <ProSidebar rtl={true} className='web' collapsed={collapsed}>
        <Menu>
          <MenuItem onClick={() => setCollapsed(!collapsed)}>
            <div className="d-flex align-items-center gap-3">
              <img src={Dashboard} alt="Dashboard Icon" className="icon mr-2" />
              <img src={Logo} alt="Logo" className="logo" />
            </div>
          </MenuItem>
          {/* <MenuItem onClick={() => { if (collapsed) { setCollapsed(!collapsed) } }}>
            <div className='input-icon border-[#00a14b]' style={{ borderColor: '#00a14b', height: '40px' }}>
              <button className='btn' ><img src={Search} alt="" /></button>
              {
                !collapsed && (
                  <input className='form-control' placeholder='جستجو...' value={searchText}
                    onChange={(e) => setSearchText(e.target.value)} onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault(); // Prevent form submission
                        navigate(`/products?categoryId= &&title=${e.target.value}`);
                      }
                    }}></input>
                )
              }
            </div>
          </MenuItem> */}
          <MenuItem className={isActive('/')} >
            <Link to="/" className="d-flex align-items-center">
              <img src={Home} alt="orders Icon" className="icon me-2" />
              خانه
            </Link>
          </MenuItem>
          <MenuItem className={isActive('/orders')}>
            <Link to="/orders" className="d-flex align-items-center">
              <img src={Basket} alt="orders Icon" className="icon me-2" />
              سبد خرید
            </Link>
          </MenuItem>
          <MenuItem className={isActive('/profile')}>
            <Link to="/profile" className="d-flex align-items-center">
              <img src={User} alt="Home Icon" className="icon me-2" />
              حساب کاربری
            </Link>
          </MenuItem>

          <MenuItem className={isActive('/order-list')}>
            <Link to="/order-list" className="d-flex align-items-center">
              <img src={Shop} alt="Products Icon" className="icon me-2" />
              سفارشات
            </Link>
          </MenuItem>
          <MenuItem className={isActive('/payment')}>
            <Link to="/payment" className="d-flex align-items-center">
              <img src={Card} alt="Products Icon" className="icon me-2" />
              پرداخت
            </Link>
          </MenuItem>
          <MenuItem className={isActive('/report')}>
            <Link to="/report" className="d-flex align-items-center">
              <img src={Report} alt="Products Icon" className="icon me-2" />
              گزارشات مالی
            </Link>
          </MenuItem>
          <MenuItem className={isActive('/tickets')} >
            <Link to="/tickets" className="d-flex align-items-center">
              <img src={Message} alt="Shop Icon" className="icon me-2" />
              تیکت ها
            </Link>
          </MenuItem>

          <MenuItem className={isActive('/notification')} >
            <Link to="/notification" className="d-flex align-items-center">
              <img src={Notif} alt="notification Icon" className="icon me-2" />
              اعلانات
            </Link>
          </MenuItem>

          <MenuItem className={isActive('/favorite')} >
            <Link to="/favorite" className="d-flex align-items-center">
              <img src={Heart} alt="favorite Icon" className="icon me-2" />
              محصولات مورد علاقه
            </Link>
          </MenuItem>

          <MenuItem className={isActive('/help')} >
            <Link to="/help" className="d-flex align-items-center">
              <img src={Info} alt="Help Icon" className="icon me-2" />
              راهنما
            </Link>
          </MenuItem>

          <MenuItem onClick={logout}>
            <div className="d-flex align-items-center">
              <img src={Logout} alt="Logout Icon" className="icon me-2" />
              خروج
            </div>
          </MenuItem>
        </Menu>
      </ProSidebar>

      < Navbar

        className="px-2 bg-body-tertiary mb-3 mobile-nav d-flex align-items-center justify-content-between"
        dir="rtl" // Setting text direction to RTL
        style={{ height: '64px' }}
      >
        <img src={MenuIcon} alt="Menu" onClick={() => setVisibleRight(true)} />
        <img src={CircleLogo} alt="Logo" width={40} />


      </Navbar >

      <PrimeSidebar
        visible={visibleRight}
        onHide={() => setVisibleRight(false)}
        position="right"
        className='menu-sidebar'
        style={{ position: 'relative', width: '80%' }}
      // showCloseIcon={false}
      >
        <Divider />
        <div className='menu-items'>
          {/* آیتم‌های ثابت */}
          <div className='d-flex align-items-center gap-2 mb-3' onClick={() => { window.location.href = '/' }}>
            <img src={Home} alt="Home" />
            <span>خانه</span>
          </div>

          <hr style={{ color: '#00a14b7a', opacity: '1' }} />

          {/* سایر آیتم‌ها */}
          <div className='d-flex align-items-center gap-2 mb-3' onClick={() => { window.location.href = '/orders' }}>
            <img src={location.pathname === "/orders" ? BasketCardActive : Basket} alt="orders" />
            <span style={location.pathname === "/orders" ? { color: '#00a14b' } : { color: '#4b5563' }}>سبد خرید</span>
          </div>
          <hr style={{ color: '#00a14b7a', opacity: '1' }} />

          <div className='d-flex align-items-center gap-2 mb-3' onClick={() => { window.location.href = '/profile' }}>
            <img src={location.pathname === "/profile" ? UserActive : User} alt="profile" />

            <span style={location.pathname === "/profile" ? { color: '#00a14b' } : { color: '#4b5563' }}>حساب کاربری</span>
          </div>
          <hr style={{ color: '#00a14b7a', opacity: '1' }} />

          <div className='d-flex align-items-center gap-2 mb-3' onClick={() => { window.location.href = '/order-list' }}>
            <img src={location.pathname === "/order-list" ? BasketActive : Shop} alt="order-list" />
            <span style={location.pathname === "/order-list" ? { color: '#00a14b' } : { color: '#4b5563' }}>سفارشات</span>
          </div>
          <hr style={{ color: '#00a14b7a', opacity: '1' }} />

          <div className='d-flex align-items-center gap-2 mb-3' onClick={() => { window.location.href = '/payment' }}>
            <img src={location.pathname === "/payment" ? CardActive : Card} alt="payment" />
            <span style={location.pathname === "/payment" ? { color: '#00a14b' } : { color: '#4b5563' }}>پرداخت</span>
          </div>
          <hr style={{ color: '#00a14b7a', opacity: '1' }} />

          <div className='d-flex align-items-center gap-2 mb-3' onClick={() => { window.location.href = '/report' }}>
            <img src={location.pathname === "/report" ? ReportActive : Report} alt="report" />
            <span style={location.pathname === "/report" ? { color: '#00a14b' } : { color: '#4b5563' }}>گزارشات مالی</span>
          </div>
          <hr style={{ color: '#00a14b7a', opacity: '1' }} />

          <div className='d-flex align-items-center gap-2 mb-3' onClick={() => { window.location.href = '/tickets' }}>
            <img src={location.pathname === "/tickets" ? MessageActive : Message} alt="tickets" />
            <span style={location.pathname === "/tickets" ? { color: '#00a14b' } : { color: '#4b5563' }}>تیکت ها</span>
          </div>
          <hr style={{ color: '#00a14b7a', opacity: '1' }} />

          <div className='d-flex align-items-center gap-2 mb-3' onClick={() => { window.location.href = '/notification' }}>
            <img src={location.pathname === "/notification" ? NotifActive : Notif} alt="notification" />
            <span style={location.pathname === "/notification" ? { color: '#00a14b' } : { color: '#4b5563' }}>اعلانات</span>
          </div>
          <hr style={{ color: '#00a14b7a', opacity: '1' }} />
          <div className='d-flex align-items-center gap-2 mb-3' onClick={() => { window.location.href = '/favorite' }}>
            <img src={location.pathname === "/favorite" ? HeartActive : Heart} alt="favorite" />
            <span style={location.pathname === "/favorite" ? { color: '#00a14b' } : { color: '#4b5563' }}>محصولات مورد علاقه</span>
          </div>
          <hr style={{ color: '#00a14b7a', opacity: '1' }} />
          <div className='d-flex align-items-center gap-2 mb-3' onClick={() => { window.location.href = '/help' }}>
            <img src={location.pathname === "/help" ? InfoActive : Info} alt="help" />
            <span style={location.pathname === "/help" ? { color: '#00a14b' } : { color: '#4b5563' }}>راهنما</span>
          </div>
          <hr style={{ color: '#00a14b7a', opacity: '1' }} />

          <div className='d-flex align-items-center gap-2 mb-3' onClick={logout}>
            <img src={Logout} alt="Employment" />
            <span>خروج از حساب کاربری</span>
          </div>
        </div>
      </PrimeSidebar>
    </>
  );
};

export default MenuComponent;
